var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 22,
    viewBox: "0 0 14 22",
    preserveAspectRatio: "xMidYMid meet",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8594 11.7969C13.2812 11.375 13.2812 10.6719 12.8594 10.25L3.76562 1.10938C3.29688 0.6875 2.59375 0.6875 2.17188 1.10938L1.09375 2.1875C0.671875 2.60938 0.671875 3.3125 1.09375 3.78125L8.3125 11L1.09375 18.2656C0.671875 18.7344 0.671875 19.4375 1.09375 19.8594L2.17188 20.9375C2.59375 21.3594 3.29688 21.3594 3.76562 20.9375L12.8594 11.7969Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.73fb0453bc45a98a88370a44f64d6395.svg";
export { ForwardRef as ReactComponent };